<template>
  <div>
    <div id="carousel-example-2" class="carousel slide" data-ride="carousel">

      <div class="carousel-inner" role="listbox">
        <div class="carousel-item active">
          <div class="view">
            <img class="d-none d-sm-block mx-auto " src="../assets/page_desarrolla_slider1.png" height="310px"
                 alt="First slide">
            <img class="d-block d-sm-none mx-auto " src="../assets/page_desarrolla_slider1.png" height="150px"
                 alt="First slide">
            <div class="mask "></div>
          </div>
          <div class="carousel-caption w-100 py-5" style="  height: 530px">
            <h1 class="h3-responsive">¿Tienes una idea?</h1>
            <h2 class="mb-5 h2-responsive">Nosotros la hacemos realidad</h2>
          </div>
        </div>
        <div class="carousel-item ">
          <div class="view" >
            <img class="d-none d-sm-block mx-auto " src="../assets/page_desarrolla_slider2.png" height="310"
                 alt="First slide">
            <img class="d-block d-sm-none mx-auto " src="../assets/page_desarrolla_slider2.png" height="150"
                 alt="First slide">
            <div class="mask "></div>
          </div>
          <div class="carousel-caption w-100 py-5" style="  height: 530px">
            <h1 class="h3-responsive">Somos especialistas en
              desarrollo de software</h1>
            <h2 class="mb-5 h2-responsive">Soluciones integrales totalmente
              adecuadas para tu negocio.</h2>
          </div>
        </div>
        <div class="carousel-item ">
          <div class="view" >
            <img class="d-none d-sm-block mx-auto " src="../assets/page_desarrolla_slider3.png" height="310"
                 alt="First slide">
            <img class="d-block d-sm-none mx-auto " src="../assets/page_desarrolla_slider3.png" height="150px"
                 alt="First slide">
            <div class="mask "></div>
          </div>
          <div class="carousel-caption w-100 py-5" style="  height: 530px">
            <h1 class="h3-responsive">Somos especialistas en
              software de análisis y automatización</h1>
            <h2 class="mb-5 h2-responsive">Soluciones integrales
              totalmente adecuadas para tu negocio.</h2>
          </div>
        </div>
      </div>
      <a class="carousel-control-prev" href="#carousel-example-2" role="button" data-slide="prev">
                <span class="" aria-hidden="true"><i
                  class="fas fa-chevron-left fa-3x "></i></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carousel-example-2" role="button" data-slide="next">
                <span class="" aria-hidden="true"><i
                  class="fas fa-chevron-right fa-3x"></i></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
    <div class="container my-5">
      <FormContact></FormContact>
    </div>
  </div>
</template>

<script>
  import FormContact from "./FormContact";

  export default {
    name: "Idea",
    components: {
      FormContact
    }
  }
</script>

<style scoped>
  .view {
    margin-top: 210px;
    margin-bottom: 60px;
  }

  span {
    color: white;
  }

  .carousel .carousel-indicators li {
    width: 5rem;
    height: .7rem;
    border-radius: 2rem;
  }

  .carousel-caption {
    top: 0px;
    left: initial;
    right: initial;
    bottom: initial;
    z-index: -10;
    background: rgba(47,57,93,1);
    background: -moz-linear-gradient(left, rgba(47,57,93,1) 0%, rgba(0,101,163,1) 100%);
    background: -webkit-gradient(left top, right top, color-stop(0%, rgba(47,57,93,1)), color-stop(100%, rgba(0,101,163,1)));
    background: -webkit-linear-gradient(left, rgba(47,57,93,1) 0%, rgba(0,101,163,1) 100%);
    background: -o-linear-gradient(left, rgba(47,57,93,1) 0%, rgba(0,101,163,1) 100%);
    background: -ms-linear-gradient(left, rgba(47,57,93,1) 0%, rgba(0,101,163,1) 100%);
    background: linear-gradient(to right, rgba(47,57,93,1) 0%, rgba(0,101,163,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#2f395d', endColorstr='#0065a3', GradientType=1 );
  }
</style>
